import React, {FC, useEffect, useState} from "react";
import {
  StateWrapper,
  GreenDot,
  Greentext
} from '../../cloud/Instances/styles'
import { useTranslation } from "react-i18next";
import { icons } from "../../../icons";
import { Button, ModalVariables, SearchComponent, StartPage, Table } from "../../../components";
import { useTheme } from "styled-components";
import { useNavigate } from "react-router";
import { useUi } from "../../../context/ui.context";
import { useAuth } from "../../../context/user.context";
import { NumberParam, StringParam, useQueryParam } from "use-query-params";
import { compareArrays } from "../../../utils/findIntersection";
import useUpdateEffect from "../../../hooks/useUpdateEffect";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { timeConverterMMDDYYHHMM } from "../../../utils/dates";
import { clientService } from "../../../api";
import { handleStatusName } from "../../../utils/handle-status-name";
import { usePageTitle } from "../../../context/navigationContext";
const DEFAULT_ORDERING = 'name';

const ClientGroups:FC = () => {
  const [clientGroups, setClientGroups] = useState<any[]>([])
  const [page, setPage] = useQueryParam('page', NumberParam);
  const [ordering, setOrdering] = useQueryParam('ordering', StringParam);
  const [pageSize, setPageSize] = useQueryParam('page_size', NumberParam);
  const [searchString, setSearchString] = useQueryParam('search', StringParam);
  const [filtering, setFiltering] = useQueryParam('filtering', StringParam);
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [paginationData, setPaginationData] = useState<any>()
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const [selectedPort, setSelectedPort] = useState<any>()
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>('')
  const [alertSubTitle, setAlertSubTitle] = useState<any[]>([])
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [checked, setChecked] = useState<any[]>([]);
  const handleResetFilters = () => {
    setSearchString(undefined);
    setFiltering(undefined);
    setOrdering(DEFAULT_ORDERING);
    setPage(1);
    setAllChecked(false);
    setChecked([]);
  }

  const {
    viewAlert,
  } = useUi()
  const {user, quotas} = useAuth()
  const editChecked = (id:any, isAll?:boolean) => {
    if(id === null) {
      setChecked([])
      setAllChecked(false)
      return
    }
    const founded = checked.find((item:any) => item.id === id?.id)
    if(founded) {
      if(isAll){ 
        return 
      } else {
        setChecked((prev:any) => {
          return prev.filter((item:any) => item.id !== id?.id)
        })
        setAllChecked(false)
      }
    } else {
      setChecked((prev) => [...prev, id])
    }
  } 
  useEffect(() => {
    if(compareArrays(clientGroups, checked) && checked?.length !== 0){
      setAllChecked(true)
    }
  },[checked])
  useUpdateEffect(() => {
    setPage(1)
  }, [pageSize, filtering])
  useEffect(() => {
    if (!ordering) {
      setOrdering(DEFAULT_ORDERING);
    }
  }, [ordering, setOrdering]);
  const [t] = useTranslation()
  usePageTitle(t("PAGE_TITLE_CLIENT_GROUPS"));
  const navigate = useNavigate()

  const _updatePorts = () => {
    // setLoading(true)
    clientService.getClientGroups({
      page:page || 1,
      page_size:pageSize || 10,
      ordering:ordering || DEFAULT_ORDERING,
      search:searchString||'',
      filtering: filtering || '',
    })
    .then((res) => {
      setClientGroups(res.data.objects.map((port:any) => {
        return {
          ...port,
          name: port.name || port.id,
          created_at:timeConverterMMDDYYHHMM(port.created_at),
        }
      }))
      setPaginationData(res.data)
      setPageLoading(false)
    })
    .catch((e) => {
      viewAlert({
        severity:'error',
        message:e?.response?.data?.detail || `${t("ERROR_OCCURRED")}`,
      })
      navigate('/home')
      setPageLoading(false)
    })
  }
  useEffect(() => {
    _updatePorts()
    const interval = setInterval(() => {
      _updatePorts()
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  },[page,
    ordering,
    pageSize,
    searchString,
    filtering])

  const openDeleteModal = (items:any[], selectedItem?:any) => {
    if (!items.length) return
    setSelectedPort(selectedItem)
    setModalType('delete')
    setAlertTitle(items.length === 1 ? t("CLIENT_GROUP") : t("CLIENT_GROUPS", { defaultValue: "Client groups" }))
    setAlertSubTitle(items)
    setViewModal(true)
    setActiveAnimation(true)
  }

  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
    setSelectedPort(undefined)
  }

  const items = [
    {
      title:t("EDIT"),
      id:'3',
      icon:icons.Edit,
      onClick: (port:any) => {
        navigate(`${port.id}/edit`)
      },
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(port:any) => {
        openDeleteModal([port], port)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]

  const Columns = [
    {
      title:t("NAME"),
      key:'name',
      sorted:true,
    },
    {
      title:t("DESCRIPTION"),
      key:'description',
    },
    {
      title:t("CREATED_AT"),
      key:'created_at',
      sorted:true,
    },
    {
      title:'',
      key:'props'
    },
  ]

  const closeModal = async () => {
    try{
      setLoading(true)
      if(selectedPort) {
        await clientService.deleteClientGroup(selectedPort.id)
        await _updatePorts()
        setChecked([])
        setAllChecked(false)
      } else if(allChecked) {
        let promises:any[] = []
        await clientGroups.map((item:any) => {
          let promise = clientService.deleteClientGroup(item.id)
          promises.push(promise)
        })
        await Promise.all(promises)
        await _updatePorts()
        await setAllChecked(false)
        await setChecked([])
      } else if (checked?.length > 0){
        let promises:any[] = []
        await checked.map((item:any) => {
          let promise = clientService.deleteClientGroup(item.id)
          promises.push(promise)
        })
        await Promise.all(promises)
        await _updatePorts()
        await setChecked([])
      }
      setLoadingComplete(true)
        setTimeout(() => {
          setLoadingComplete(false)
          setLoading(false)
        },1000)
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
      _updatePorts()
      setPageLoading(false)
      setLoadingComplete(false)
      setLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
      setSelectedPort(undefined)
    } 
  }


  const _createFunc = () => {
    navigate('create')
  }
  return (
    <>
    {/* @ts-ignore */}
      <StartPage
        title={t("CLIENT_GROUPS", { defaultValue: "Client groups" })}
        noResourceText={t("NO_CLIENT_GROUPS", { defaultValue: "No client groups" })}
        createResourceButton={t('CREATE_CLIENT_GROUP', { defaultValue: "Create client group" })}
        createResourceButtonEventOrLink={_createFunc}
        haveResource={clientGroups.length > 0}
        withoutCreateResourceButton
        rightCustomCreateButton={
          <div style={{display:'flex', flexDirection:'column', gap:'10px', width:'100%'}}>
            <div style={{display:'flex', alignItems:'center', gap:'12px', width:'100%'}}>
              <Button
                title={t('CREATE_CLIENT_GROUP', { defaultValue: "Create client group" })}
                onClick={_createFunc}
                variant='primary'
                size='custom'
                customStyles={{height:'40px', whiteSpace:'nowrap'}}
              />
              <div style={{flex:1, minWidth:'200px'}}>
                <SearchComponent />
              </div>
              <Button
                onClick={() => {
                  openDeleteModal(allChecked ? clientGroups : checked)
                }}
                variant='icon'
                size='display'
                test_id='button-delete'
                disabled={!allChecked && checked?.length === 0 }
              >
                <img src={icons.DeleteIcon}/>
              </Button>
              <Button
                title={t("CLEAR_FILTERS")}
                onClick={handleResetFilters}
                variant='stroke'
                size='display'
                disabled={
                  (!filtering || filtering === '') &&
                  !searchString &&
                  ordering === DEFAULT_ORDERING
                }
              />
            </div>
          </div>
        }
        pageLoading={pageLoading}
        tableData={{
          columns:Columns,
          data:clientGroups,
          props:items,
          allChecked:allChecked,
          setAllChecked:setAllChecked,
          checked:checked,
          setChecked:editChecked,
          paginationData:paginationData,
          updateData:_updatePorts
        }}
      />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        loading={loading}
        loadingComplete={loadingComplete}
      />
    </>
  )
}


export default ClientGroups
